import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { formatHtml } from 'sanitize-text/sanitizers/HtmlSanitizer';
import { useAriaLiveContext } from 'visitor-ui-component-library/utils/aria-live/AriaLiveContext';
import { isInSDK } from '../utils/isInSDK';
import { jsx as _jsx } from "react/jsx-runtime";
export const ContentTextWrapper = styled.div.withConfig({
  displayName: "ContentText__ContentTextWrapper",
  componentId: "bq2avb-0"
})(["word-wrap:break-word;box-sizing:border-box;width:100%;a{font-weight:inherit;text-decoration:underline;}img{max-width:100%;height:auto;}annotation{display:none;}math[display='block']{padding:8px 0;}p:not(:last-child){margin-bottom:8px;}"]);
const ContentText = props => {
  const {
    'aria-label': ariaLabel,
    contentText,
    messageId,
    onClickAction = () => {},
    shouldAnnounce
  } = props;
  const ref = useRef(null);
  const {
    announce
  } = useAriaLiveContext();
  useEffect(() => {
    if (shouldAnnounce) {
      announce({
        id: messageId || ariaLabel,
        text: ariaLabel
      });
    }
  }, [announce, ariaLabel, messageId, shouldAnnounce]);
  return /*#__PURE__*/_jsx(ContentTextWrapper, {
    children: /*#__PURE__*/_jsx("div", {
      ref: ref,
      "aria-label": ariaLabel,
      dir: "auto",
      "data-test-id": "primary-message-content"
      // eslint-disable-next-line react/no-danger
      ,
      dangerouslySetInnerHTML: {
        __html: formatHtml(contentText, {
          shouldPreserveMathML: true,
          shouldPreserveNewlines: true,
          shouldOpenLinksInNewTab: isInSDK(),
          allowedDomainsForIframe: [/^\/?\/?play\.vidyard\.com\/[a-zA-Z0-9]*\.html$/gm]
        })
      },
      onClick: onClickAction
    })
  });
};
ContentText.displayName = 'ContentText';
ContentText.propTypes = {
  'aria-label': PropTypes.string,
  contentText: PropTypes.string.isRequired,
  messageId: PropTypes.string,
  onClickAction: PropTypes.func,
  shouldAnnounce: PropTypes.bool
};
export default ContentText;